import { Icon, Modal, Spin } from "ant-design-vue";
import { Component, Ref, Vue } from "vue-property-decorator";
import { ActionItem, fmtMsg, MessageHelper, NotificationType, ServerExceptionCode } from "commonui";
import Grid from "@/components/wijmo-grid/grid/grid.vue";
import { ConversationTemplateService, UtteranceEntitiesModel } from "@/services/conversation-templates";
import { CommonEntitiesFormLocale, CommonLocale, UtteranceEntitiesLocale } from "@/locales/localeid";
import { GridRef } from "@/components/wijmo-grid/grid/grid";
import CommonEntitiesForm from "@/components/common-entities-form/common-entities-form.vue";
import { AccessLevel } from "@/util/enum";
import { getRouteAccessLevel, disabledDueToAccessLevel } from "@/util/func";

@Component({
	components: {
		Grid,
		Icon,
		Spin,
		ActionItem,
		CommonEntitiesForm
	}
})
export default class UtteranceEntities extends Vue {
	@Ref() readonly gridCompRef!: GridRef;
	private templateService = ConversationTemplateService();
	public loading: boolean = false;
	public format = fmtMsg;
	public locale = UtteranceEntitiesLocale;
	public commonEntityFormLocale = CommonEntitiesFormLocale;
	public commonLocale = CommonLocale;
	public isAddEditDrawerVisible = false;
	public commonEntities: UtteranceEntitiesModel[] = [];
	public selectedEntityId: number = 0;
	public accessLevel = AccessLevel;

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	created() {
		this.getUtteranceCommonEntities();
	}

	getUtteranceCommonEntities() {
		this.loading = true;
		this.templateService
			.getEntities()
			.then((data) => {
				this.commonEntities = data;
				this.loading = false;
			})
			.catch(() => {
				this.loading = false;
			});
	}

	showErrorMessage({ error_code, error_description }) {
		switch (error_code) {
			case ServerExceptionCode.CommonEntityAssociationException:
				MessageHelper.Message(
					NotificationType.Failed,
					this.format(this.locale.UtteranceEntitiesStrongAssociationMessage)
				);
				break;
			case ServerExceptionCode.CommonEntityNotExistException:
				MessageHelper.Message(
					NotificationType.Failed,
					this.format(this.commonEntityFormLocale.CommonEntitiesFormItemsEntityNotExistMessage)
				);
				break;
			case ServerExceptionCode.ArgumentIsNullOrInvalidException:
				MessageHelper.Message(
					NotificationType.Failed,
					this.format(this.commonLocale.CommonHttpArgumentIsNullOrInvalid)
				);
				break;
		}
	}

	deleteCommonEntity(id: number) {
		const onOk = async () => {
			this.loading = true;
			this.templateService
				.deleteEntity(id)
				.then((data) => {
					this.loading = false;
					MessageHelper.Message(
						NotificationType.Success,
						this.format(this.locale.UtteranceEntitiesDeleteSuccessMessage)
					);
					this.getUtteranceCommonEntities();
				})
				.catch(({ error_code, error_description }) => {
					this.showErrorMessage({ error_code, error_description });
					this.loading = false;
				});
		};

		Modal.confirm({
			okText: fmtMsg(this.locale.UtteranceEntitiesDeleteButtonText),
			title: fmtMsg(this.locale.UtteranceEntitiesDeleteWarning),
			onOk
		});
	}

	addEditEntity(id?: number) {
		if (!id) {
			// New Entity
			this.selectedEntityId = 0;
		} else {
			this.selectedEntityId = id;
		}
		this.isAddEditDrawerVisible = true;
	}

	onAddEditDrawerClose(reloadRequired: boolean) {
		this.isAddEditDrawerVisible = false;
		if (reloadRequired) {
			this.getUtteranceCommonEntities();
		}
	}
}
